import { useEffect } from "react";
import Footer from "../Common/Footer";
import Header from "../Common/Header";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <Header />
        <div className="content-wrapper " style={{ marginTop: 70 }}>

          <div className="contactus">
            <div className="contact-page">

              {/* Header */}
              <div className="contact-header">
                <h1>Contact Us</h1>
                <p>
                  We're here to help. Reach out to us for any queries, support, or
                  business inquiries.
                </p>
              </div>

              {/* Main Section */}
              <div className="contact-container">

                {/* Left Card */}
                <div className="contact-card">
                  <div className="company">
                    <div className="icon"><i class="ri-building-4-line text-2xl text-emerald-600"></i></div>
                    <div>
                      <h2>Geton Infotech Pvt Ltd</h2>
                      <p>Parent Company of LandPanda</p>
                    </div>
                  </div>

                  <div className="company info d-flex">
                    <div className="icon"><i class="ri-mail-line text-emerald-600"></i></div>
                    <div>
                      <span>EMAIL</span>
                      <p>info@getoninfotech.com</p>
                      <p>info@landpanda.com</p>
                    </div>


                  </div>

                  <div className="company info d-flex">
                    <div className="icon"><i class="ri-phone-line text-emerald-600"></i></div>


                    <div>
                      <span>MOBILE</span>
                      <p>+91 87960 11518</p>
                    </div>


                  </div>

                  <div className="company info d-flex">
                    <div className="icon"><i class="ri-map-pin-line text-emerald-600"></i></div>



                    <div>
                      <span>ADDRESS</span>
                      <p>
                        Geton Infotech Pvt Ltd <br />
                        2nd Floor, C-130, Noida Sector 2,<br />
                        Uttar Pradesh - 201301
                      </p>
                    </div>
                  </div>



                  <div className="actions">
                    <button className="call"><i class="ri-phone-fill"></i> Call Now</button>
                    <button className="email">✉ Send Email</button>
                  </div>
                </div>

                {/* Map Card */}
                <div className="map-card">
                 
                 <div className="mapdetails"> <h3>Find Us on Map</h3>
                  <p>Visit our office at Noida Sector 2, Uttar Pradesh</p>
</div>
                  <iframe
                    title="map"
                    src="https://maps.google.com/maps?q=noida%20sector%202&t=&z=13&ie=UTF8&iwloc=&output=embed" style={{height:400}}
                  />
                </div>
              </div>

              {/* Business Hours */}
              <div className="business-hours">
               <div className="d-flex">
                 <div className="icon iconnsss"><i class="ri-time-line text-emerald-600"></i></div>
                  <h3>Business Hours</h3>
                 </div>

                <div className="hours-grid">
                  <div className="hour-box">
                    <span>MONDAY - FRIDAY</span>
                    <p>9:00 AM - 6:00 PM</p>
                  </div>

                  <div className="hour-box">
                    <span>SATURDAY</span>
                    <p>10:00 AM - 4:00 PM</p>
                  </div>

                  <div className="hour-box">
                    <span>SUNDAY</span>
                    <p>Closed</p>
                  </div>

                  <div className="hour-box">
                    <span>SUPPORT</span>
                    <p className="online" style={{color:'green'}}>24/7 Online</p>
                  </div>
                </div>
              </div>

              <div className="back">← Back to Home</div>
            </div>
          </div>
        </div>
        <Footer /></div>
    </>
  );
}

export default Contact;
